import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { INDUSTRIES } from 'src/app/data/industries';
import { REMOVESPACESONLY, VALIDEMAILREGEX } from "src/app/helpers/helperResources";
import { CompaniesService } from 'src/app/services/client-services/companies.service';
import { COUNTRIES } from "src/app/data/nations";
import { STATES } from "src/app/data/states";
import { GeneralService } from 'src/app/services/general.service';
import $ from 'jquery';

@Component({
  selector: 'app-create-company-form',
  templateUrl: './create-company-form.component.html',
  styleUrls: ['./create-company-form.component.css']
})
export class CreateCompanyFormComponent implements OnInit {
  @Output() emitEvent = new EventEmitter();
  config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Country", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search",
  };
  config2 = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select State", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search",
  };
  loader: any = {
    default: "notch-loader",
    spinnerType: "",
    spinnerStyle: {},
    dataless: {
      title: "No Data Available!",
      subTitle: "Please add a company and try again",
      action: "Add Company",
      success: true,
    },
    import: {
      spinnerType: "jsBin",
      spinnerStyle: { left: "45%", top: "45%" },
      showSpinner: false,
    },
    showSpinner: false,
    btnSpinner: false,
    export: false,
  };
  nations: Observable<any>;
  states: Observable<any>;
  companyForm: FormGroup;
  loading = false;
  autoSuggestion = "";
  arrayIndustries = INDUSTRIES;
  swalInfo: Observable<any>;
  filterResponseIfExist = new Subject<any>();
  companies: any;
  salesPersonList: any;
  loggedInUser = this.genSer.user;
  loadingView = false;

  
  constructor(
    private fb: FormBuilder,
    private companyServ: CompaniesService,
    private toastr: ToastrService,
    public genSer: GeneralService,
  ) { 
    this.nations = new Observable((observer) => {
      observer.next(this.extractValueFromObject(COUNTRIES, "name"));
    });
    this.states = new Observable((observer) => {
      observer.next(this.extractValueFromObject(STATES, "value"));
    });
    this.createForm();
  }

  ngOnInit() {
    this.subscribeToPhoneNumberChanges();
  }
  // Create Company
  createForm() {
    this.companyForm = this.fb.group({
      name: ["", [Validators.required, REMOVESPACESONLY]],
      industry: ["", REMOVESPACESONLY],
      email: ["", [Validators.pattern(VALIDEMAILREGEX), REMOVESPACESONLY]],
      phoneNumber: ["", [Validators.pattern("^[0-9]{10}$"), REMOVESPACESONLY]],
      country: ["", REMOVESPACESONLY],
      state: ["", REMOVESPACESONLY],
    });
  }

  subscribeToPhoneNumberChanges() {
    this.companyForm.get('phoneNumber').valueChanges.subscribe(value => {
      const formattedValue = this.formatPhoneNumber(value);
      this.companyForm.get('phoneNumber').setValue(formattedValue, { emitEvent: false });
    });
  }

  formatPhoneNumber(value: string): string {
    if (!value) {
      return value;
    }

    if (value.startsWith('+234')) {
      value = value.substring(4);
    } else if (value.startsWith('234')) {
      value = value.substring(3);
    }

    if (value.startsWith('0')) {
      value = value.substring(1);
    }

    return value;
  }

  get f() {
    return this.companyForm.controls;
  }
  handleCompanyWildcard() {
    const companyName = this.companyForm.value.name;
    if (companyName) {
      this.companyServ.getWildcardCompanies(companyName).subscribe((res) => {
        const { success, payload } = res;
        if (success && payload.length > 0) {
          this.loading = true;
          let all = "";
          for (const iterator of payload) {
            all += iterator.name + ",";
          }
          this.autoSuggestion = all;
          return;
        } else {
          this.loading = false;
          this.autoSuggestion = "";
          return;
        }
      });
    } else {
      this.loading = false;
      this.autoSuggestion = "";
      return;
    }
  }
  handleCheckIfExist(databaseColumnName) {
    this.swalInfo = new Observable((observer) => {
      observer.next({});
    });
    const {
      value: { email, phoneNumber },
    } = this.companyForm;
    let filterQuery;
    let queryType;
    switch (databaseColumnName) {
      case "email":
        filterQuery = `email=${email}`;
        queryType = "emailType";
        break;

      case "phoneNumber":
        filterQuery = `phoneNumber=${phoneNumber}`;
        queryType = "phoneNumberType";
        break;
    }
    this.filterApi(true, filterQuery, queryType);
    this.filterResponseIfExist.subscribe((res) => {
      if (res.length > 0 && res) {
        if (queryType === "phoneNumberType") {
          this.swalInfo = new Observable((observer) => {
            observer.next({ phoneNumber });
            this.companyForm.controls.phoneNumber.setErrors({
              incorrect: true,
            });
          });
        } else {
          this.swalInfo = new Observable((observer) => {
            observer.next({ email });
            this.companyForm.controls.email.setErrors({ incorrect: true });
          });
        }
      }
    });
  }
  validateNumber(event) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46];

    if (
      !(
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 96 && keyCode <= 105) ||
        excludedKeys.includes(keyCode)
      )
    ) {
      event.preventDefault();
    }
  }
  // Extract the country name from the list
  private extractValueFromObject(object, key) {
    const dropDown = [];
    switch (key) {
      case "name":
        object.forEach((element) => {
          dropDown.push(element.name);
        });
        break;
      case "value":
        object.forEach((element) => {
          dropDown.push(element.value);
        });
        break;
    }
    return dropDown;
  }
  private async filterApi(valid, filterQuery, queryType) {
    if (valid) {
      const arrayCompany: {payload;success;} = await this.companyServ.getCompaniesByFilter(filterQuery).toPromise();
      
      if (arrayCompany && arrayCompany.success) {
        if (queryType === "sideBar") {
          // this.companies = arrayCompany.payload;
          this.companies = await this.addOwnerToContactArray(
            arrayCompany.payload
          );
          // this.dataTable.dataChangedObs.next(true);
        } else if (queryType === "emailType") {
          this.filterResponseIfExist.next(arrayCompany.payload);
          // this.dataTable.dataChangedObs.next(true);
        } else if (queryType === "phoneNumberType") {
          this.filterResponseIfExist.next(arrayCompany.payload);
          // this.dataTable.dataChangedObs.next(true);
        } else {
          this.companies = [];
          // this.dataTable.dataChangedObs.next(true);
        }
      }
      (error) => {
        let msg = "Error filtering data. Please clear to try again!";
        msg =
          error && error.error && error.error.message
            ? error.error.message
            : msg;
        this.toastr.error(msg, "Filter Error");
      };
    }
  }
  // Add Owner to Contact Array (for Filter by SalesPerson)
  private async addOwnerToContactArray(defaultSource: any) {
    let owner = [];
    defaultSource.filter((d) => {
      let creator = { ...d, ownerName: "None" };
      this.salesPersonList.filter((s) => {
        if (d.owner === s.id) {
          creator["ownerName"] = s.name;
        }
      });
      owner.push(creator);
    });
    return owner;
  }
  // Create Company
  async handleCompanyCreation() {
    this.loader.btnSpinner = true;
    // const companyDetails = this.companyDetails;
    const body = {
      ...this.companyForm.value,
      owner: this.loggedInUser.id,
      creatorName: `${this.loggedInUser.firstName} ${this.loggedInUser.lastName}`,
      otherInfo: {},
      leadId: 0,
      profileImage: "http://ssl.gstatic.com/accounts/ui/avatar_2x.png",
    };
    this.loadingView = true;
    $("#ModalCenter4 .close").click();
    this.genSer
      .sweetAlertFileCreations("Company")
      .then(async (res) => {
        if (res.value) {
          const { payload, success } = await this.companyServ
            .createCompanies(body)
            .toPromise();
          if (!success) this.toastr.error(payload);
          else this.toastr.success("Company created successfully!");
         
          // await this.intializeCompany();
          this.companyForm.reset();
          this.nations = new Observable((observer) => {
            observer.next(this.extractValueFromObject(COUNTRIES, "name"));
          });
          this.states = new Observable((observer) => {
            observer.next(this.extractValueFromObject(STATES, "value"));
          });
          this.loadingView = false;
          this.emitEvent.emit({status: 'success'})
        }
      })
      .finally(() => {
        this.loader.btnSpinner = false;
        // this.dataTable.dataChangedObs.next(true);
      });
  }

}
